<template>
  <section class="atp card mb-0">
    <header class="atp__head">
      <b>Активные задачи ({{ tasks.length }})</b>
      <button type="button" class="btn btn-link btn-sm p-0 atp__toggle" :aria-expanded="String(open)" @click="$emit('toggle')">
        {{ open ? 'Свернуть' : 'Развернуть' }}
      </button>
    </header>
    <div v-if="open" class="atp__body">
      <div v-if="status === 'error'" class="atp__state text-danger">
        Не удалось загрузить задачи
        <button type="button" class="btn btn-sm btn-light ml-2 atp__retry" @click="$emit('retry')">Повторить</button>
      </div>
      <div v-else-if="status === 'loading'" class="atp__state text-muted">Загрузка…</div>
      <div v-else-if="tasks.length === 0" class="atp__state text-muted">Назначенных задач нет</div>
      <article v-for="t in tasks" :key="t.id" class="atp__item">
        <div class="atp__id">
          T‑{{ t.id }}
          <span v-if="isOverdue(t.deadline_date)" class="atp__badge">Просрочена</span>
        </div>
        <div class="atp__obj">{{ (t.geo_location && t.geo_location.name) || '—' }}</div>
        <div class="text-muted small">{{ (t.assignee && t.assignee.username) || '—' }}</div>
        <div class="text-muted small">Дедлайн: {{ isoToRu(t.deadline_date) }}</div>
        <ul class="atp__works">
          <li v-for="(fw, i) in (t.field_works || [])" :key="i">— {{ (fw.type && fw.type.title) || '—' }}</li>
        </ul>
        <div v-if="t.description" class="atp__comment">{{ t.description }}</div>
        <div class="atp__actions">
          <button type="button" class="btn btn-sm btn-outline-secondary atp__focus" :disabled="!isFocusable(t)" @click="$emit('focus', t)">На карте</button>
          <span v-if="!isFocusable(t)" class="small text-muted">нет на карте</span>
          <button type="button" class="btn btn-sm btn-outline-secondary atp__edit" :disabled="status !== 'ready'" @click="$emit('edit', t)">Изменить</button>
          <button type="button" class="btn btn-sm btn-outline-danger atp__cancel" :disabled="status !== 'ready'" @click="$emit('cancel', t)">Отменить</button>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { isoToRu, isOverdue } from '@/components/management/dispatcher/format';

export default {
  name: 'ActiveTasksPanel',
  props: {
    tasks: { type: Array, default: () => [] },
    focusTargets: { type: Object, default: () => ({}) },
    status: { type: String, default: 'idle' },
    open: { type: Boolean, default: true },
  },
  methods: {
    isoToRu,
    isOverdue,
    isFocusable(task) {
      const target = this.focusTargets[task.id];
      return !!(target && target.ok);
    },
  },
};
</script>

<style scoped lang="scss">
.atp { border: 1px solid #e3e5e1; border-radius: 10px; }
.atp__head { display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-bottom: 1px solid #eceee9; font-size: 13px; }
.atp__body { padding: 8px 12px; display: flex; flex-direction: column; gap: 10px; }
.atp__state { font-size: 12.5px; padding: 6px 0; }
.atp__item { border: 1px solid #eceee9; border-radius: 9px; padding: 10px 12px; font-size: 12.5px; display: flex; flex-direction: column; gap: 3px; }
.atp__id { font-family: monospace; color: #8b918c; font-size: 11px; }
.atp__badge { margin-left: 6px; background: #fbeae5; color: #c0492b; font-size: 10.5px; font-weight: 800; padding: 1px 6px; border-radius: 5px; font-family: sans-serif; }
.atp__obj { font-weight: 800; }
.atp__works { list-style: none; padding: 0; margin: 2px 0; color: #4c524d; }
.atp__comment { background: #f4f5f1; border-radius: 7px; padding: 6px 8px; color: #4c524d; }
.atp__actions { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin-top: 6px; }
</style>
